export default function formatReadingDurationHms(
  seconds: number | null | undefined,
): string {
  if (seconds == null || seconds < 0) return '00:00:00';
  const total = Math.floor(seconds);
  const hh = Math.floor(total / 3600);
  const mm = Math.floor((total % 3600) / 60);
  const ss = total % 60;
  return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
}
